import { Can } from 'components/Can';
import { DetailM08 } from 'features/Council/pages';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

export default function AcceptanceReviewDetailM08Page() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <Can do="read" on="acceptance_review">
          <DetailM08 />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}
